export const trapFocus = (
  elements: Array<HTMLElement>
): ((e: KeyboardEvent) => void) => {
  if (elements.length === 0) {
    return () => { 
      //  do nothing 
    };
  }

  const firstElement = elements[0];
  const lastElement = elements[elements.length - 1];

  const keyDownHandler = (e: KeyboardEvent) => {
    if (e.key !== "Tab") return;

    if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }

    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    }

    if (!elements.includes(document.activeElement as HTMLElement)) {
      e.preventDefault();
      firstElement.focus();
    }
    return;
  };

  return keyDownHandler;
};
